import { css } from 'lit';

export const FigureCaptionStyle = css`

.toggle-btn {
  margin: var(--lds-spacing-figure-caption-margin-top) var(--lds-spacing-figure-caption-margin-right) var(--lds-spacing-figure-caption-margin-bottom) var(--lds-spacing-figure-caption-margin-left);
  font-family: var(--lds-typography-figure-caption-font-family);
  cursor: pointer;
  background: 0 0;
  display: inline-block;
  border: var(--lds-border-figure-caption-width) var(--lds-border-figure-caption-style) var(--lds-color-figure-caption-border);
  border-radius: var(--lds-border-figure-caption-radius);
  transition: var(--lds-animation-figure-caption-transition);
  padding-right: calc(var(--lds-spacing-figure-caption-padding-right) - var(--lds-border-figure-caption-width));
  padding-left: calc(var(--lds-spacing-figure-caption-padding-left) - var(--lds-border-figure-caption-width));
  padding-top: calc(var(--lds-spacing-figure-caption-padding-top) - var(--lds-border-figure-caption-width));
  padding-bottom: calc(var(--lds-spacing-figure-caption-padding-bottom) - var(--lds-border-figure-caption-width));
  font-size: var(--lds-typography-figure-caption-font-size);
  font-weight: var(--lds-typography-figure-caption-font-weight);
  line-height: var(--lds-typography-figure-caption-line-height);
  color: var(--lds-color-figure-caption);
  background-color: var(--lds-color-figure-caption-background);
  box-shadow: var(--lds-shadow-figure-caption);
}



.toggle-btn:hover {
  background-color: var(--lds-color-figure-caption-background-hover);
}

.toggle-btn:focus {
  outline-color: var(--lds-color-figure-caption-outline);
  outline-style: var(--lds-border-figure-caption-outline-style);
  outline-width: var(--lds-border-figure-caption-outline-width);
  box-shadow: var(--lds-shadow-figure-caption-focus);
}

.lds-figure-caption-toggle-icon {
  margin-right: var(--lds-spacing-figure-caption-toogle-icon-margin-right);
  transition: var(--lds-animation-figure-caption-transition-toogle-icon);
  color: var(--lds-color-figure-caption-toggle-icon);
  box-shadow: none;
  display: inline-block;
  width: var(--lds-spacing-figure-caption-toogle-icon-width);
  height: var(--lds-spacing-figure-caption-toogle-icon-height);
  vertical-align: middle;
  fill: currentColor;
}



.lds-figure-caption-toggle-icon.open {
  transform: translateY(-.1rem) rotate(180deg);
}

.toggle-btn.noCollapse {
  display: none;
}
`;

export default FigureCaptionStyle;
